<template>
    <transition name="modal">
        <div>
            <div class="modal" tabindex="-1" role="dialog" @keyup.esc="cancelModal">
                <div class="modal__dialog">
                    <button class="modal__close" type="button" @click="cancelModal">
                        x
                    </button>
                    <div class="modal__content">
                        <slot/>
                        <h3 class="u-padding-bottom">{{ trans('order.upload-custom-csr-modal-title') }}</h3>
                        <div role="alert" dusk="alert" class="alert alert--danger" v-if="error">
                            {{error}}
                            <button type="button" aria-label="Close" class="alert-close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <label for="custom_csr">{{ trans('order.custom-csr-input-title') }}</label>
                        <textarea
                            id="custom_csr"
                            name="custom_csr"
                            class="field__message"
                            v-model="csrField"
                            rows="10"
                            @input="csrTextOnChange"
                        >
                        </textarea>

                        <div class="layout">
                            <div class="layout__item u-2/4-desk">
                                <small>{{ trans('order.csr-upload-without-private-key') }}</small>
                            </div>
                            <div class="layout__item u-2/4-desk u-text-right">
                                <button
                                    v-model="csrIsValidated"
                                    type="button"
                                    class="btn btn--ghost"
                                    @click="validateCsr"
                                >
                                    {{ trans('order.validate-csr') }}
                                </button>
                            </div>
                        </div>
                        <div class="non-centering-container" v-if="csrIsValidated == true">
                            <div class="layout">
                                <div class="layout__item">
                                    <h3>{{ trans('order.csr-validation-result') }}</h3>
                                </div>
                            </div>
                            <div class="layout">
                                <div class="layout__item">
                                    <table class="table-responsive table table">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>&nbsp;</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(result,key) in results">
                                                <td><span>{{key}}</span></td>
                                                <td>&nbsp;</td>
                                                <td><span>{{result}}</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="layout u-padding-top">
                            <div class="layout__item u-2/4-desk">
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn--ghost"
                                        @click="cancelModal()"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <div class="layout__item u-2/4-desk u-text-right">
                                <button
                                    :disabled="!csrIsValidated"
                                    type="button"
                                    class="btn btn--blue btn--nav"
                                    @click="submitCsr"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop" role="presentation" @click="clickBackdrop"/>
            <div v-if="isLoading" class="spinner-wrapper">
                <div class="overlay"/>
                <span class="spinner"/>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {SslApi} from 'relapp-technical-management';
import ssl from "../../../technical-management/src/services/api/ssl";

export default {
    name: "CustomCsrModal",
    props: {
        isLoading: {
            type: Boolean,
            required: false
        },
        closeOnClickBackdrop: {
            type: Boolean,
            required: false
        },
        domain: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            csrField: '',
            csrIsValidated: false,
            results: [],
            error:null
        }
    },
    computed: {
        /**
         * Generate the state classes.
         *
         * @return {object}
         */
        stateClasses() {
            return {
                'has-error': this.error
            };
        }
    },
    methods: {
        ...mapActions({
            updateSslCsr: 'order/updateSslCsr',
            updateSslGenerateCsr: 'order/updateSslGenerateCsr'
        }),
        /**
         * Handle clicks on the backdrop.
         */
        clickBackdrop() {
            if (this.closeOnClickBackdrop) {
                this.closeModal();
            }
        },
        /**
         * Cancel the modal
         */
        cancelModal(){
            this.$root.$emit('cancellingModal',this.domain);
        },
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
            this.$root.$emit('closedModal');
            this.csrField = '';
        },
        /**
         * After changing the textarea we dont want the to submit any weird changes.
         */
        csrTextOnChange(){
           this.csrIsValidated = false;
        },
        /**
         * Validate the csr
         */
        validateCsr() {
            this.csrIsValidated = false;
            this.error = null;
            SslApi.validateCsr(this.csrField, this.domain.domain)
                .then(response => {
                    this.results = response.data;
                    this.csrIsValidated = true;
                })
                .catch(error => {
                    this.error = error.data.message;
                });
        },
        /**
         * Submitting is only available when the csr is succesfully validated.
         */
        submitCsr() {
            if (this.csrIsValidated === true) {
                this.$root.$emit('submitValidatedCsr', this.csrField, this.domain);
                this.$root.$emit('closedModal');
                this.csrField = '';
            }
        }
    }
};
</script>
